/**
 * StudySync Notifications Hook
 * Manages notification state and provides methods to show notifications
 */

import { useState, useCallback } from 'react';
import { NotificationData } from '../components/common/NotificationPopup';

export const useNotifications = () => {
  const [notification, setNotification] = useState<NotificationData | null>(null);

  const showNotification = useCallback((
    type: 'success' | 'error' | 'info' | 'warning',
    title: string,
    message: string,
    action?: string
  ) => {
    const newNotification: NotificationData = {
      id: Date.now().toString(),
      type,
      title,
      message,
      action,
      timestamp: new Date()
    };
    setNotification(newNotification);
  }, []);

  const showSuccess = useCallback((title: string, message: string, action?: string) => {
    showNotification('success', title, message, action);
  }, [showNotification]);

  const showError = useCallback((title: string, message: string, action?: string) => {
    showNotification('error', title, message, action);
  }, [showNotification]);

  const showInfo = useCallback((title: string, message: string, action?: string) => {
    showNotification('info', title, message, action);
  }, [showNotification]);

  const showWarning = useCallback((title: string, message: string, action?: string) => {
    showNotification('warning', title, message, action);
  }, [showNotification]);

  const clearNotification = useCallback(() => {
    setNotification(null);
  }, []);

  return {
    notification,
    showNotification,
    showSuccess,
    showError,
    showInfo,
    showWarning,
    clearNotification
  };
};

export default useNotifications;
